import {VEHICLESLIST_TYPE} from './types';

export const getVehicleslist = data => ({
  type: VEHICLESLIST_TYPE,
  payload: data,
});
